module.exports = __webpack_public_path__ + "static/media/success.6a7ed847.svg";